module.exports = __webpack_public_path__ + "img/poster_txt_yl.9e25bbca.png";